/**
 * Created by JAVIER on 10/5/2019.
 */

import {sortTree} from '../utils/functions'
import BaseService from './base.service'

class PhotoService extends BaseService {
    async getTreeData(folderId) {
        const url = folderId ? '/api/v1/photos/tree?folderId=' + folderId : '/api/v1/photos/tree';
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const data = await response.json()
        sortTree(data)
        return data
    }

    async getImportTreeData(folderId) {
        const url = folderId ? '/api/v1/photos/import/tree?folderId=' + folderId : '/api/v1/photos/import/tree';
        const response = await
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            })
        this.handleHttpErrors(response)
        const data = await
            response.json()
        sortTree(data)
        return data
    }

    async getPhotos(folderId) {
        const response = await fetch(
            `/api/v1/photos/tree/folder/files?folderId=${folderId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }
        )
        const data = await response.json()
        return data.files
    }

    async saveFolder(folder, folderPath) {
        const response = await fetch(`/api/v1/photos/tree/folder`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({folder: folder, folderPath: folderPath}),
            credentials: 'same-origin',
        })

        const folders = await response.json()
        console.log('saveFolder: rsp ', folders)
        return folders[0]
    }

    async deletePhoto(photoId) {
        const response = await fetch(`/api/v1/photos/file/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({fileId: photoId}),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async moveFolder(srcFolderId, targetFolderId) {
        const response = await fetch(`/api/v1/photos/folder/paste`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pasteFolderId: targetFolderId,
                cutFolderId: srcFolderId,
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async moveFiles(srcFileIds, targetFolderId) {
        const response = await fetch(`/api/v1/photos/file/paste`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pasteFolderId: targetFolderId,
                cutFileIds: srcFileIds,
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async deleteFolder(folderId) {
        const response = await fetch(`/api/v1/photos/folder/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async generateFolderSharedLink(folderId) {
        const response = await fetch(`/api/v1/photos/folder/share/generatelink`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({folderId: folderId}),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveFolderSecurity(folderId, folderPath, securityDetail) {
        const response = await fetch(`/api/v1/photos/folder/security/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId,
                folderPath: folderPath,
                securityDetail: JSON.stringify(securityDetail),
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveStyles(folderId, folderPath, iconColor, textStyle, textSize) {
        const body = {
            folderId: folderId,
            folderPath: folderPath,
            stateColor: iconColor,
            boldText: textStyle.includes('bold') ? 'on' : undefined,
            italicText: textStyle.includes('italic') ? 'on' : undefined,
            textSize: textSize,
        }

        const response = await fetch(`/api/v1/photos/folder/properties/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveFolderComments(folderId, comments) {
        const body = {
            folderId: folderId,
            comments: comments,
        }

        const response = await fetch(`/api/v1/photos/folder/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveFileComments(fileId, comments) {
        const body = {
            fileId: fileId,
            comments: comments,
        }

        const response = await fetch(`/api/v1/photos/file/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveShared(fileIds, shared) {

        const body = {
            fileIds: fileIds,
            shared: shared
        }

        const response = await fetch(`/api/v1/photos/file/shared`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveRotation(fileId, rotation) {

        const body = {
            fileId: fileId,
            rotation: rotation
        }

        const response = await fetch(`/api/v1/photos/file/rotation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async saveManyRotations(fileIds, rotation) {

        const body = {
            fileIds: fileIds,
            rotation: rotation
        }

        const response = await fetch(`/api/v1/photos/files/rotation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async savePhotoImport(options) {
        console.log('OPTIONS', options)

        const formData = new FormData()

        formData.set('file', options.file, options.file.name)
        formData.set('data', JSON.stringify(options.data))

        const res = await fetch('/api/v2/importPhotos', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        })

        const rsp = await res.json()
        return rsp
    }

    async getImportPhotos() {

        const response = await fetch(
            `/api/v2/importPhotos`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }
        );
        const data = await response.json();
        return data
    }

    async deleteImportPhotos(selectedPhotoIds) {
        const response = await fetch(`/api/v2/importPhotos/` + selectedPhotoIds, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        });
        if (response.headers.get('Content-Length') === '0') {
            return '';
        }
        else {
            const rsp = await response.json();
            return rsp;
        }
    }


    async searchImportPhotos(searchText) {
        const res = await fetch("/api/v2/importPhotos/search/" + searchText, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
            ,
            credentials: "same-origin"
        });
        const search = await res.json();
        return search;
    }

}


const photoService = new PhotoService()

export default photoService
